<template>
  <div :class="['m-edition-asset-content-node',
    isTask ? 'm-edition-asset-content-node-task' : '']">
    <Block
      v-for="(block, index) in texto.blocks"
      :key="index"
      :is="`MoleculeContentNodeBlock${block.type}`"
      :block="block"
    />
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentNode',

  components: {
    MoleculeContentNodeBlockAudio: () => import('@/components/molecules/MoleculeContentNodeBlockAudio'),
    MoleculeContentNodeBlockDocument: () => import('@/components/molecules/MoleculeContentNodeBlockDocument'),
    MoleculeContentNodeBlockIframeVideo: () => import('@/components/molecules/MoleculeContentNodeBlockIframeVideo'),
    MoleculeContentNodeBlockImage: () => import('@/components/molecules/MoleculeContentNodeBlockImage'),
    MoleculeContentNodeBlockLink: () => import('@/components/molecules/MoleculeContentNodeBlockLink'),
    MoleculeContentNodeBlockParagraph: () => import('@/components/molecules/MoleculeContentNodeBlockParagraph'),
    MoleculeContentNodeBlockTitle1: () => import('@/components/molecules/MoleculeContentNodeBlockTitle1')
  },

  props: {
    isTask: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    texto () {
      if (this.isTask && this.$route.name === 'map') {
        return this.$store.getters.getSelectedMapNodeTask.texto
          ? JSON.parse(this.$store.getters.getSelectedMapNodeTask.texto)
          : { blocks: [] }
      } else if (!this.isTask && this.$route.name === 'map') {
        return this.$store.getters.getSelectedMapNode.texto
          ? JSON.parse(this.$store.getters.getSelectedMapNode.texto)
          : { blocks: [] }
      } else if (!this.isTask && (this.$route.name === 'asset' ||
        this.$route.name === 'assetChild2')) {
        return this.$store.getters.getSelectedNode.texto
          ? JSON.parse(this.$store.getters.getSelectedNode.texto)
          : { blocks: [] }
      } else {
        return {}
      }
    }
  }
}
</script>
